import { useEffect, useState } from 'react';
import { useFlexSearchIndex } from './useFlexSearchIndex';
import { useLocalSearchArticles } from './useLocalSearchArticles';
import axios from 'axios';

const SEARCH_THRESHOLD = 0.15;

export const useSearch = (query) => {
  const { index, store } = useLocalSearchArticles();
  const searchIndex = useFlexSearchIndex(index);
  const [results, setResults] = useState([]);
  const [robertaResults, setRobertaResults] = useState([]);

  useEffect(
    function fetchResultsFromRoberta() {
      if (!query) return;

      const timer = setTimeout(async () => {
        try {
          const resp = await axios.get(
            `${process.env.GATSBY_SEMANTIC_SEARCH_BASE_URL}/api/v1/search?query=${query}&limit=10`
          );
          const { results } = resp.data;

          setRobertaResults(
            results
              .filter(({ score }) => score >= SEARCH_THRESHOLD)
              .map(
                (r) =>
                  r?.topic_url && {
                    id: r.article_id,
                    title: r.article_name,
                    content: r.article_content?.data?.article_content,
                    topic: r?.topic_url,
                    url: r.article_url
                  }
              )
              .filter((article) => article)
          );
        } catch (error) {
          console.warn('Failed to retrieve results. Roberta response:\n', error);
          setRobertaResults([]);
        }
      }, 500);
      return () => clearTimeout(timer);
    },
    [query]
  );

  useEffect(
    function getResultsFromFlexSearch() {
      if (!query || !searchIndex || !(store && Object.keys(store).length)) return;

      let rawResults = searchIndex.search(query.toLowerCase(), 25);
      setResults((rawResults.result || rawResults).map((id) => store[id]));
    },
    [query, searchIndex, store]
  );

  return (function () {
    if (!results.length) {
      return [robertaResults, robertaResults.length, 'semantic-search'];
    }
    return [results, results.length, 'flexsearch'];
  })();
};
